<template>
    <div>        
        <list label="Pzns" v-bind:refresh="this.refresh" table='currentpzns' v-on:childMessage="onMessageFromListReceived" initialSortBy="pharmacyname" :initialSortDesc="true" :hideNewAndEdit="true" :hideDelete="true" :hideExport="true"></list>                
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"

export default {
    components:
    {
        List
    },

    data()
    {
        return {
            showDialog: "",
            fields: [],
            refresh: 0,
            title: "",
            text: ""
        };
    },    

    mixins: [Utils],

    methods:
    {
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {                
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("details");
                this.fields = JSON.parse(JSON.stringify(message.header));
                for (let field of this.fields)
                {                    
                    field.model = message.item[field.value]
                }

                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {                
            }
        },
        cancel ()
        {
            this.showDialog = "";
            this.fields = [];
        }        
    }
};
</script>